<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{path: '/home'}">首页</el-breadcrumb-item>
      <el-breadcrumb-item>生产单元数据</el-breadcrumb-item>
      <el-breadcrumb-item>移动机器人电量管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <div>
        <h3>请选择要查询的范围：</h3>
        <el-form :model="inquireList" ref="addFormRef" label-width="80px" class="form">
          <div class="from01">
            <div>
              <el-form-item label="订单1" prop="TypeName">
                <el-select v-model="inquireList.number01" placeholder="请选择订单" clearable>
                  <el-option v-for="item in ordersList" :key="item.ID" :label="item.OrderName" :value="item.ID">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="订单2" prop="TypeName">
                <el-select v-model="inquireList.number02" placeholder="请选择订单" clearable>
                  <el-option v-for="item in ordersList" :key="item.ID" :label="item.OrderName" :value="item.ID">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="bytn01">
              <el-button type="primary" @click="getNumber()">查 询</el-button>
            </div>
          </div>
        </el-form>
      </div>
      <div class="echart01">
        <div ref="chart" style="width: 100%; height: 400%"></div>
      </div>
    </el-card>
  </div>
</template>

<script>
import * as echarts from 'echarts'

export default {
    data () {
        return {
            getTypeList: {
                page: '1',
                limit: '100',
                privateKey: '12a5081e-e354-bada-3952-7a0df30d8849',
                appIdentification: 'wms',
                tableName: 'Mes_Order'
            },
            // 订单信息列表
            ordersList: [],
            // 查询所需
            inquireList: {
                number01: '',
                number02: ''
            }
        }
    },
    created () {
        this.getOrderList()
    },
    mounted () {
        this.init()
    },
    methods: {
        init (number) {
            const myChart = echarts.init(this.$refs.chart)
            var number01 = []
            var number02 = []
            var number03 = []
            if (number.length > 0) {
                for (let i = 0; i < number.length; i++) {
                    number01.push(number[i].EleQuantity)
                    number02.push(number[i].OrderNO)
                    number03.push(number[i].UseEleQuantity)
                }
            }
            const option = {
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['电量', '用电量']
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                toolbox: {
                    feature: {
                        saveAsImage: {}
                    }
                },
                xAxis: {
                  name: '订单号',
                    type: 'category',
                    boundaryGap: false,
                    data: number02,
                    // axisLabel: {
                    //     interval: 0
                    // }
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        name: '电量',
                        type: 'line',
                        data: number01
                    },
                    {
                        name: '用电量',
                        type: 'line',
                        data: number03
                    }
                ]
            }
            myChart.setOption(option)
        },
        // 调用接口获取订单信息
        async getOrderList () {
            const { data: res } = await this.$http.get('/WMS/GeneralQuery', { params: this.getTypeList })
            console.log(res.data)
            this.ordersList = res.data
        },
        // 调用接口获取图表数据
        async getNumber () {
            let params = new URLSearchParams();
            if (!this.inquireList.number01) return this.$message.error('请选择要查询的订单范围！')
            if (!this.inquireList.number02) return this.$message.error('请选择要查询的订单范围！')
            params.append("num1", this.inquireList.number01)
            params.append("num2", this.inquireList.number02)
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            console.log('159753' + params)
            const { data: res } = await this.$http.get('/WMS/OrderPower', { params })
            console.log(res.data)
            this.init(res.data)
        }
    }
}
</script>

<style lang="less" scoped>
.echart01 {
  width: 50%;
  height: 90%;
}
.from01 {
  display: flex;
}
.bytn01 {
  margin-left: 3%;
}
</style>
